module.exports = __webpack_public_path__ + "img/2.8d0562c5.png";